module.exports = __webpack_public_path__ + "img/small.53a32103.png";